import { updateLinksAttributes } from '../utils/handleAttributes';

export default function slideshow(widgetNameVariable, widgetOptsVariable, vimeoWidgetNameVariable) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);
  let swiperImages;
  let swiperContent;

  const slideDelay = 5000;
  const enableDescription = false;
  const firstSlideMainHeading = false; // enable this if you need to set the first title as H1 instead of H2

  const buttonLabels = {
    purchaseLabel: 'Buy Now',
    moreLabel: 'More',
  };

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>

    <div class="swiper-pagination"></div>

    <div class="content-wrap">
      <div class="content-wrap-container">
        <div class="content-wrap-inner">
        <div class="swiper-button-prev desktop-arrows"></div>
            <div class="swiper-container swiper-container-content">
              <div class="swiper-wrapper"></div>
            </div>
            <div class="swiper-button-next desktop-arrows"></div>
        </div>
      </div> 
    </div>  
  `;

  // Slide Template - Content
  function buildSlideTemplateContent(slide, _isFirstSlide) {
    let title;
    if (firstSlideMainHeading) {
      title = _isFirstSlide
        ? `<h1 class="slide-title">${slide.Title}</h1>`
        : `<h2 class="slide-title">${slide.Title}</h2>`;
    } else {
      title = `<h2 class="slide-title">${slide.Title}</h2>`;
    }
    const description = `<p class="slide-description">${slide.Description}</p>`;

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="wrap-content-slide">
          ${title}
          ${enableDescription ? description : ''}
          </div>
          ${buttons(slide.URL, slide.PurchaseURL, buttonLabels)}
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    if (widgetData.length <= 1) {
      $(`#${widgetName} .content-wrap .swiper-wrapper`).addClass('single-slide');
    }
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide, index) {
      let isFirstSlide = index == 0;
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide, isFirstSlide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: slideDelay,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        init: function () {
          updateImageA11y(this);
        },
        slideChangeTransitionEnd: function () {
          updateImageA11y(this);
        },
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      watchOverflow: true,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
      on: {
        init: function () {
          updateSlideA11y(this);
        },
        slideChangeTransitionEnd: function () {
          updateSlideA11y(this);
        },
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

    swiperImages = swiperWidgetImages;
    swiperContent = swiperWidgetContent;

    // Observer to stop autoplay when user is not looking at the slider
    const sliderToObserve = $(`#${widgetName} .swiper-container-images`).get(0);
    if (sliderToObserve) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              swiperWidgetImages.autoplay.start();
            } else {
              swiperWidgetImages.autoplay.stop();
            }
          }
        },
        { threshold: 0.3 },
      );

      observer.observe(sliderToObserve);
    }
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      initSwiper(response.Slides);
      $(`#${vimeoWidgetNameVariable}`).remove();
      updateSwiper(swiperImages, swiperContent);
    } else {
      $('body').addClass(`${widgetName}-no-data`);
    }
  });
}

function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}

// Updating active slides content
function updateSlideA11y(swiper) {
  const $slides = $(swiper.slides);

  $slides.attr({
    'aria-selected': 'false',
    'aria-hidden': 'true',
    tabindex: '-1',
    inert: '',
  });

  $slides.find('a, button').attr('tabindex', '-1');

  const $active = $slides.filter('.swiper-slide-active');

  $active.removeAttr('inert').attr({
    'aria-selected': 'true',
    'aria-hidden': 'false',
    tabindex: '0',
  });

  $active.find('a, button').attr('tabindex', '0');
}

function updateImageA11y(swiper) {
  const $slides = $(swiper.slides);

  $slides.each(function (_, slide) {
    const $slide = $(slide);
    const isActive = $slide.hasClass('swiper-slide-active');

    $slide.attr('aria-hidden', isActive ? 'false' : 'true');
  });
}

// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

  return template;
}

const buttons = function (btn1, btn2, buttonLabels) {
  if (btn1 || btn2) {
    let btnContainer = $('<div class="button-container"></div>');
    if (btn1) {
      btnContainer.append(
        `<a href="${btn1}" class="button" ${updateLinksAttributes(btn1, buttonLabels.moreLabel)}>${buttonLabels.moreLabel}</a>`,
      );
    }
    if (btn2) {
      btnContainer.append(
        `<a href="${btn2}" class="button" ${updateLinksAttributes(btn2, buttonLabels.purchaseLabel)}>${buttonLabels.purchaseLabel}</a>`,
      );
    }
    return btnContainer.prop('outerHTML');
  } else {
    return '';
  }
};
